import { jsx } from 'react/jsx-runtime';
import { useContext, useState, useEffect, useMemo, createContext } from 'react';

const DragAndSelectContext = /* @__PURE__ */ createContext(void 0);
const DragAndSelectProvider = ({ children, selectedIds, clearSelection }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [dragOriginId, setDragOriginId] = useState(null);
  const [dragState, setDragState] = useState(null);
  useEffect(() => {
    try {
      document.body.dataset.dragSelectActive = `${isDragging}`;
    } catch {
    }
  }, [
    isDragging
  ]);
  const value = useMemo(() => ({
    selectedIds,
    isDragging,
    setIsDragging,
    dragOriginId,
    setDragOriginId,
    dragState,
    setDragState,
    clearSelection
  }), [
    selectedIds,
    isDragging,
    dragOriginId,
    dragState,
    clearSelection
  ]);
  return /* @__PURE__ */ jsx(DragAndSelectContext.Provider, {
    value,
    children
  });
};
const useDragAndSelect = () => useContext(DragAndSelectContext);

export { DragAndSelectProvider, useDragAndSelect };
//# sourceMappingURL=DragAndSelectContext.js.map
